import React from 'react'

// BaseMap's privacy policy has one home, on the marketing site (PO-230). The panel used to frame a 2018 copy
// bundled with this app; it now links to the current policy, which is too wide to frame in this panel.
export const PRIVACY_POLICY_URL = 'https://www.basemap.com/privacy-policy'

const PrivacyPolicy = () => (
  <div>
    <div className='settings-units-container' style={{ padding: '16px', fontSize: '14px' }}>
      <p style={{ marginBottom: '16px' }}>
        Our privacy policy explains what BaseMap collects, how we use it, what we share with apps and AI
        assistants you connect, and your choices.
      </p>
      <a
        className='settings-privacy-link'
        href={PRIVACY_POLICY_URL}
        target='_blank'
        rel='noopener noreferrer'
        style={{ color: '#589500', fontWeight: 'bold' }}>
        Read the privacy policy
      </a>
    </div>
  </div>
)

export default PrivacyPolicy
